import { withRouter } from 'react-router-dom';
import ToolingLocationForm from './ToolingLocationsForm';

export default withRouter(ToolingLocationForm);



// WEBPACK FOOTER //
// ./src/components/ToolingLocations/ToolingLocationsForm/index.jsx